import { useState, useEffect, useCallback } from 'react';
import { getIntegrationStatus, disconnectIntegration } from '../services/integration.service';

/**
 * Hook: integration connection status for the current member.
 *
 * Returns:
 *   status     — { google_calendar, fitbit, apple_health } each with { connected, last_sync_at }
 *   isLoading
 *   error
 *   disconnect(service) — disconnect and refresh
 *   refresh
 */
export function useIntegrations() {
  const [status, setStatus]     = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [error, setError]       = useState(null);

  const fetch = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await getIntegrationStatus();
      setStatus(data);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not load integrations.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetch(); }, [fetch]);

  const disconnect = useCallback(async (service) => {
    try {
      await disconnectIntegration(service);
      await fetch();
    } catch (err) {
      setError(err.response?.data?.error || 'Could not disconnect.');
    }
  }, [fetch]);

  return { status, isLoading, error, disconnect, refresh: fetch };
}
